import PropTypes from 'prop-types'

import colors from 'components/utils/colors'
import Badge from 'components/Shared/Badge/Index'

const Filter = ({ title, value, color, onClear, clearTooltip, tooltipId }) => {
  return (
    <Badge
      key={title || value}
      onDelete={onClear}
      color={color || colors.secondary95}
      deleteTooltip={clearTooltip}
      deleteTooltipId={tooltipId}
      margin='0'
    >
      {title && (title + ': ')}
      {value}

    </Badge>
  )
}

Filter.propTypes = {
  value: PropTypes.string.isRequired,
  title: PropTypes.string,
  color: PropTypes.string,
  onClear: PropTypes.func,
  clearTooltip: PropTypes.string,
  tooltipId: PropTypes.string,
}

export default Filter
